
import { Loader2 } from 'lucide-react';

const LoadingState = () => {
  return (
    <div className="flex justify-center items-center h-64">
      <Loader2 className="h-16 w-16 animate-spin text-adhirachna-green" />
    </div>
  );
};

export default LoadingState;
